export default [

    {
        title: 'Структура ЖД',
        icon: 'HomeIcon',
        children: [
            {
                title: 'Железные дороги',
                route: 'railway_structure-railway-list',
                action: 'read',
                resource: 'railway',
            },
            {
                title: 'Участки',
                route: 'railway_structure-sector-list',
                action: 'read',
                resource: 'sector',
            },
            {
                title: 'Станции',
                route: 'railway_structure-station-list',
                action: 'read',
                resource: 'station',
            },
            {
                title: 'Платформы',
                route: 'railway_structure-platform-list',
                action: 'read',
                resource: 'platform',
            },
            {
                title: 'Мостовые переходы',
                route: 'railway_structure-bridge-list',
                action: 'read',
                resource: 'bridge',
            },
            {
                title: 'Навесы',
                route: 'railway_structure-shed-list',
                action: 'read',
                resource: 'shed',
            },
            {
                title: 'Торцевые ограждения',
                route: 'railway_structure-fencing-list',
                action: 'read',
                resource: 'fencing',
            },
            {
                title: 'Опоры',
                route: 'railway_structure-pillar-list',
                action: 'read',
                resource: 'pillar',
            },
            {
                title: 'Контактные провода',
                route: 'railway_structure-contact_wire-list',
                action: 'read',
                resource: 'contactwire',
            },
            {
                title: 'Несущие провода',
                route: 'railway_structure-main_wire-list',
                action: 'read',
                resource: 'mainwire',
            },
        ],

    },

]
